"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneDisplayValueExtCasting = exports.phoneDisplayValueCasting = void 0;
const phoneDisplayValueCasting = (value) => value.replace(/(.{2})(\d{3})(\d{3})(\d{2})(\d{2})/g, `$1 ($2) $3-$4-$5`);
exports.phoneDisplayValueCasting = phoneDisplayValueCasting;
const phoneDisplayValueExtCasting = (value) => {
    let cleanValue = value.replace(/\D/g, '');
    if (cleanValue.length === 11 && cleanValue[0] === '8') {
        cleanValue = '7' + cleanValue.slice(1);
    }
    if (cleanValue.length === 10) {
        cleanValue = '7' + cleanValue;
    }
    return cleanValue.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5');
};
exports.phoneDisplayValueExtCasting = phoneDisplayValueExtCasting;
